<template>
  <div>
    <b-modal @hidden="$parent.closeAltaEntidad()" hide-footer size='lg' ref='modalEntidades' id="modalEntidades"
             title="Gestión Entidad">
      <b-card class="mb-16">
        <div>
          <h5>Buscar Entidad</h5>
        </div>
        <div>
          <b-input v-model="cif" v-validate="'required'" type="search" id="searchEntity" ref="searchEntity"
                   placeholder="Introduce el CIF" autofocus class="input-search-entity"></b-input>
          <b-button @click="searchEntity" variant="primary">Buscar</b-button>
        </div>
      </b-card>
      <b-card>
        <b-form>
          <div>
            <h5>Datos Entidad</h5>
          </div>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity || foundedEntity" class="font-size-1rem" label="CIF *">
                  <b-form-input v-model="entity.cif" v-validate="'required'" name="Cif"></b-form-input>
                  <span class="error">{{ errors.first('Cif') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Nombre *">
                  <b-form-input v-model="entity.nombre_entidad" v-validate="'required'" name="Nombre"
                                :state="(searchedEntity && this.fields && this.fields['Nombre'].invalid) ? false : null">
                  </b-form-input>
                  <span class="error">{{ errors.first('Nombre') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Tipo Entidad *">
                  <b-form-select v-model="entity.id_tipo_entidad" :options="entity_types" value-field="id"
                                 text-field="text" name="Tipo Entidad" v-validate="'required'" class="select-size"
                                 :state="(searchedEntity && this.fields && this.fields['Tipo Entidad'].invalid) ? false : null"/>
                  <span class="error">{{ errors.first('Tipo Entidad') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Dirección *">
                  <b-form-input v-model="entity.direccion" v-validate.immediate="'required'" name="Dirección"
                                :state="(searchedEntity && this.fields && this.fields['Dirección'].invalid) ? false : null">
                  </b-form-input>
                  <span class="error">{{ errors.first('Dirección') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col :cols='4'>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Código SAP">
                  <b-form-input v-model="entity.codigo_entidad"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <br>
          <div>
            <h5>Datos Contacto</h5>
          </div>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Nombre y Apellidos">
                  <b-form-input v-model="entity.datos_contacto"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Teléfono Principal">
                  <b-form-input v-model="entity.telefono_principal"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group :disabled="!searchedEntity" class="font-size-1rem" label="Email Principal">
                  <b-form-input v-model="entity.email_principal" name="Email Principal"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>

          <br>

          <b-row>
            <b-col class="text-align-right">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-checkbox v-model="entity.enviar_notificacion" v-if="!foundedEntity" class="d-block mr-16" >
                  Enviar notificación
                </b-form-checkbox>
                <multiselect
                  id="multiselect-request-user"
                  v-model="entity.usuario_solicitante"
                  :options="usersList"
                  label="username"
                  track-by="username"
                  placeholder=""
                  v-if="!foundedEntity"
                  :disabled="!entity.enviar_notificacion"
                  :custom-label="getCustomLabelUser"
                  size="sm"
                  class="multiselect-user w-25 mx-16">
                </multiselect>
                <b-button v-if="!foundedEntity" :disabled="!searchedEntity" @click="createEntity" variant="primary">
                  Alta
                </b-button>
                <b-button v-if="foundedEntity" :disabled="!searchedEntity" @click="updateEntity" variant="primary">
                  Actualizar
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
      <b-alert v-model="showSuccessAlert" variant='success' dismissible class="success-alert">
        {{ successMessage }}
      </b-alert>
      <b-alert v-model="showErrorAlert" variant='danger' dismissible class="error-alert">
        {{ errorMessage }}
      </b-alert>
    </b-modal>
  </div>
</template>

<style scoped>
.mb-16 {
  margin-bottom: 16px;
}

.mx-16 {
  margin: 0 16px !important;
}

.font-size-1rem {
  font-size: 1rem;
}

.text-align-right {
  text-align: right;
}

.input-search-entity {
  margin-top: 12px;
  margin-bottom: 16px;
}

.select-size {
  min-height: 40px;
}

.success-alert {
  margin-top: 16px;
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}

.error-alert {
  margin-top: 16px;
  color: #721c24 !important;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
}
</style>

<script>

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'AltaEntidad',
  props: ['permisos'],
  components: {},
  data: function () {
    return {
      entity_types: [
        {id: 1, text: 'Empresa Colaboradora'},
        {id: 2, text: 'Cuentas Nacionales'},
        {id: 3, text: 'Administradores Fincas'}
      ],
      searchedEntity: false,
      foundedEntity: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      successMessage: '',
      errorMessage: '',
      cif: '',
      entity: {
        cif: '',
        nombre_entidad: '',
        direccion: '',
        id_tipo_entidad: '',
        codigo_entidad: '', // codigo_sap
        datos_contacto: '',
        telefono_principal: '',
        email_principal: '',
        enviar_notificacion: false,
        usuario_solicitante: {}
      },
      usersList: []
    };
  },
  mounted: function () {
    this.initData();
    this.$refs.modalEntidades.show();
    this.$refs.searchEntity.focus();
  },
  methods: {
    initData: function () {
      const self = this;
      Promise.all([
        this.$http.get('usuarios-activos/')
      ]).then(response => {
        self.usersList = response[0].data;
      });
    },
    getCustomLabelUser: function (option) {
      return (option.id) ? `${option.username} - ${option.first_name} ${option.last_name}` : '';
    },
    searchEntity: function () {
      this.$http.get(`entidades/by-cif/${this.cif}/`).then(response => {
        this.searchedEntity = true;
        this.foundedEntity = response.data !== '';
        if (this.foundedEntity) {
          this.entity = response.data;
        } else {
          this.entity = {cif: this.cif};
          this.$validator.reset();
        }
      });
    },
    createEntity: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          this.showErrorMessage('El formulario contiene algunos errores, por favor revise los valores introducidos');
        } else {
          this.$http.post('entidades/', this.entity).then(response => {
            this.showSuccessMessage.bind(this)('Entidad creada correctamente');
          }, reason => {
            this.showErrorMessage.bind(this)('Error al crear la entidad');
          });
        }
      });
    },
    updateEntity: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          this.showErrorMessage.bind(this)('El formulario contiene algunos errores, por favor revise los valores introducidos');
        } else {
          this.$http.put(`entidades/${this.entity.id}/`, this.entity).then(response => {
            this.showSuccessMessage.bind(this)('Entidad actualizada correctamente');
          }, reason => {
            this.showErrorMessage.bind(this)('Error al actualizar la entidad');
          });
        }
      });
    },
    showSuccessMessage: function (message) {
      this.showSuccessAlert = true;
      this.successMessage = message;
    },

    showErrorMessage: function (message) {
      this.showErrorAlert = true;
      this.errorMessage = message;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/AltaEntidad.vue